import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import { connect } from "react-redux";

const mapStateToProps = ({ auth }) => ({ auth });
const connector = connect(mapStateToProps);

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const { className, auth } = props;

  const classes = useStyles();
  const user = {
    name: getUserName(),
    avatar: '/images/avatars/avatar.png',
    bio: 'Brain Director'
  };

  function getUserName() {
    const noName = "Aucun nom";
    if(! auth.user) {
      return noName;
    }

    if(! auth.user.displayName) {
      return noName;
    }

    return auth.user.displayName;
  }

  return (
    <div
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user.avatar}
        to="/settings"
      />
      <Typography
        className={classes.name}
        variant="h4"
      >
        {user.name}
      </Typography>
      <Typography variant="body2">{user.bio}</Typography>
    </div>
  );
};

export default connector(Profile);
